import { RENTAL_VEHICLES } from "@/data/vehicles";
import type { Locale } from "@/config/i18n";

export const LOCATION_BOOKING_FORM_ID = "location-booking-form";

export const getVehicleOptions = () =>
  RENTAL_VEHICLES.map((vehicle) => ({
    id: vehicle.id,
    label: `${vehicle.name} (${vehicle.brand})`,
  }));

export const getVehicleById = (vehicleId: string | undefined) => {
  if (!vehicleId) return undefined;
  return RENTAL_VEHICLES.find((item) => item.id === vehicleId);
};

export const getVehicleLabelById = (vehicleId: string | undefined) => {
  const match = getVehicleById(vehicleId);
  if (!match) return "";
  return `${match.name} (${match.brand})`;
};

export const getVehicleIdFromSearchParams = (value: string | null) => {
  if (!value) return "";
  const exists = RENTAL_VEHICLES.some((vehicle) => vehicle.id === value);
  return exists ? value : "";
};

export const buildLocationBookingHref = (
  vehicleId: string,
  locale: Locale = "fr",
) => {
  const base =
    locale === "en" ? "/en/location/vehicules" : "/location/vehicules";
  return `${base}?vehicle=${encodeURIComponent(vehicleId)}#${LOCATION_BOOKING_FORM_ID}`;
};
